import dayjs from 'dayjs';

export const daysFilterValue = [
  {
    text: 'today',
    value: dayjs().startOf('day').toDate(),
    value2: dayjs().startOf('day').add(1, 'day').toDate(), // start next day
  },
  {
    text: 'yesterday',
    value: dayjs().subtract(1, 'day').startOf('day').toDate(),
    value2: dayjs().subtract(1, 'day').startOf('day').add(1, 'day').toDate(),
  },
  {
    text: 'currentWeek',
    value: dayjs().startOf('day').day(1).toDate(), // Monday 00:00
    value2: dayjs().startOf('day').day(1).add(7, 'day').toDate(), // next Monday 00:00 (semi-open)
  },
];

export const daysFilterValueMobile = [
  {
    text: 'today',
    value: new Date(dayjs().add(0, 'day')),
    value2: new Date(dayjs().add(1, 'day')),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().add(-1, 'day')),
    value2: new Date(dayjs().add(0, 'day')),
  },
  {
    text: 'lastWeek',
    value: new Date(dayjs().add(-(dayjs().day() + 7 - 1), 'day')),
    value2: new Date(dayjs().add(-(dayjs().day() + 0 - 1), 'day')),
  },
];

export const periodItemsData = [
  {
    key: 'previousPeriod',
    renderElement: 'previousPeriod',
    selectedRenderElement: 'previousPeriod',
    active: true,
  },
];

export const providersNames = {
  pragmaticplay: 'Pragmatic Play',
  pragmaticslots: 'Pragmatic Play',
  pragmaticlivecasino: 'Pragmatic Live',
  pragmaticblackjack: 'Pragmatic BlackJack',
  softgamingslots: 'SoftGaming',
  goldenrace: 'Goldenrace',
}

export const sortFieldsForMobile = ['provider', 'betAmount', 'winAmount', 'betCount', 'incomeAmount'];
